module.exports = __webpack_public_path__ + "img/serveWeichat.58c2a029.jpg";